<label *ngIf="title?.length">{{title}}</label>
<div *ngIf="!hasSegments; else stacked" class="progress" [style.height.px]="height" [style.min-width.px]="minWidth">
    <div [class]="progressClass()" role="progressbar" [style.width.%]="percentage()" [attr.aria-valuenow]="value" [attr.aria-valuemin]="min" [attr.aria-valuemax]="max">
        <span *ngIf="!isNoPercentage" title="{{percentage()}}%">{{percentage()}}%</span>
    </div>
</div>
<ng-template #stacked>
    <div class="progress-stacked position-relative" [style.height.px]="height" [style.min-width.px]="minWidth">
        <div *ngFor="let segment of orderedSegments; let i = index" 
            role="progressbar"
            class="progress h-100" 
            [class.position-absolute]="isStacked"
            [attr.aria-label]="segment.label"
            [style.width.%]="percentage(segment)" 
            [style.left.%]="start(segment)"
            [style.z-index]="zIndex(i)"
            [attr.aria-valuenow]="segment.value"
            [attr.aria-valuemin]="min"
            [attr.aria-valuemax]="stackedMax"
            data-bs-toggle="tooltip" 
            [attr.data-bs-html]="hintHasTags(segment)" 
            data-bs-placement="top" 
            [title]="segment.hint"
            (mouseenter)="mouseEnter(segment, i)"
            (mouseleave) ="mouseLeave(segment, i)">
            <div [class]="progressClass(segment)" [style]="progressStyle(segment)"></div>
        </div>
    </div>
</ng-template>

<!--ng-template #stacked>
    <div class="progress-stacked" [style.height.px]="height" [style.min-width.px]="minWidth">
        <div *ngFor="let segment of orderedSegments" class="progress" role="progressbar" [attr.aria-label]="segment.label" [style.width.%]="percentage(segment)" [attr.aria-valuenow]="segment.value" [attr.aria-valuemin]="min" [attr.aria-valuemax]="stackedMax(segment)" data-bs-toggle="tooltip" [attr.data-bs-html]="hintHasTags(segment)" data-bs-placement="top" [title]="segment.hint">
            <div [class]="progressClass(segment)" [style]="progressStyle(segment)"></div>
        </div>
    </div>
</ng-template//-->